/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var deparam = require('lib/vendor/jquery-deparam-patched').default;

	// Handles:
	//  • getting/setting query and filters
	//  • notifying search-related internal modules (SearchResultDisplay, SearchResultFilter, SearchResultClusterSuggestions, SearchResultQueryBox) of changed config (query/filters).
	//      Note: all of these need a class “searchInternal”.
	//  • communication with outside (NPE header search field, URL-Hash)
	var SearchResultContainer = Module.extend({
		// The current query
		query: null,
		// The current filters in the following form:
		// {
		// 		Area: '1_residential1_residential'
		// }
		filter: {},
		// Force the session to change (or remain) on the next request
		sessionOptions: null,
		// Keep track of search queries that were triggered by changed filters (relevant for tracking)
		fromFilterChange: false,
		// Array of all internal search modules that need be notified if the config changes
		internals: null,
		// How many result displays are currently loading
		loading: 0,

		on: function(callback) {
			if(this.debug) {
				window.searchResultContainer = this;
			}
			// Create a long-lasting options object
			this.sessionOptions = {};
			callback();
		},

		after: function() {
			var mod = this;
			mod.findElements();
			// Use a timeout to guarantee that the dependent modules’ “after” initializers have run
			window.setTimeout(function() {
				mod.queryFromHash();
			}, 0);
		},

		findElements: function() {
			var mod = this;
			this.internals = [];

			// Find the element where the search params are configured. Prefer the main modSearchResultDisplay accordion
			mod.$config = mod.$ctx.find('.modSearchResultDisplay.search-configuration');
			if(mod.$config.length !== 1) {
				// Find the config that is first in the DOM (from the search field)
				mod.$config = mod.$ctx.find('.search-configuration:eq(0)');
			}

			this.$ctx.find('.mod.searchInternal').each(function() {
				var modules = mod.sandbox.getModuleInstances(this);
				$.each(modules, function(i, module) {
					if('initSearch' in module) {
						mod.internals.push(module);
					}
				});
			});
			
			$.each(this.internals, function(i, module) {
				module.initSearch(mod);
			});
			
			$(window).on('hashchange', function() {
				mod.queryFromHash();
			});
		},

		currentConfig: function() {
			return {
				query: this.query,
				filter: this.filter,
				sessionOptions: this.sessionOptions,
				fromFilterChange: this.fromFilterChange
			};
		},

		internalModulesByName: function(modName) {
			var result = [];
			$.each(this.internals, function(i, module) {
				if(module.modName === modName) {
					result.push(module);
				}
			});
			return result;
		},

		configChanged: function(fromFilterChange) {
			var mod = this;

			mod.configUpdated();

			// Keep track of search queries that were triggered by changed filters
			mod.fromFilterChange = !!fromFilterChange;

			$.each(this.internals, function(i, module) {
				if('searchConfigChanged' in module) {
					module.searchConfigChanged(mod.currentConfig(), mod);
				}
			});
			
		},

		// Called when the search logic has changed the configuration but a new search should not immediately be triggered.
		configUpdated: function() {
			var mod = this;

			// fire custom event so header search fields can update themselves
			$(document).trigger('scsSiteSearch-serp-query', [mod.query, mod.filter]);

			$.each(this.internals, function(i, module) {
				if('searchConfigUpdated' in module) {
					module.searchConfigUpdated(mod.currentConfig(), mod);
				}
			});

			mod.updateHash();
		},

		updateHash: function() {
			var param = SCS.search.util.param;

			var params = {};
			if(this.query) {
				params.q = this.query;
			}
			// Paramizing empty objects yields the empty string.
			// When leaving the filter as an object, there would be no way to distinguish
			// between the explicit and the implicit case for no filters set.
			params.filter = param(this.filter);
			
			// TODO: if the query or filter wasn’t previously represented in the hash, use location.replace so that arrow navigation is still correct
			window.location.hash = '#' + param(params);
		},

		queryFromHash: function() {
			var hash = window.location.href;
			var index = hash.indexOf('#');
			if(index > -1) {
				hash = hash.substring(index + 1);
			} else {
				hash = '';
			}
			hash = deparam(hash);
			var changed = false;
			if(hash.q && hash.q !== this.query) {
				changed = true;
				this.query = hash.q;
			}
			if('filter' in hash && hash.filter !== SCS.search.util.param(this.filter)) {
				changed = true;
				this.filter = deparam(hash.filter);
			}
			if(changed) {
				this.configChanged();
			}
		},

		startLoading: function() {
			this.loading += 1;
			this.updateLoading();
		},

		stopLoading: function() {
			this.loading -= 1;
			this.updateLoading();
		},

		updateLoading: function() {
			var mod = this;

			if(mod.loading < 0) {
				mod.log.warn('Loading indicator counter below 0', mod.loading);
			}
			mod.$ctx.toggleClass('loading', mod.loading > 0);

			if(mod.loading === 0) {
				$.each(mod.internals, function(i, module) {
					if('searchProcessingDone' in module) {
						module.searchProcessingDone(mod.currentConfig(), mod);
					}
				});
			}
		}

	});

	SearchResultContainer.ellipsis = function ellipsis(elements) {
		elements.each(function () {
			var element = $(this),
				previousMaxHeight = this.style.maxHeight || 'none',
				previousHeight = this.style.height || 'auto',
				targetHeight = element.height(),
				lineHeight = parseInt(element.css('line-height'), 10),
				maxLines = Math.max( (targetHeight / lineHeight), 1),
				maxCutCharacters = 400,
				text = element.text();

			if (targetHeight > 0) {
				element.css({
					'max-height': 'none',
					'height': 'auto'
				});
				var currentLines = Math.round(element.height() / lineHeight);
				// jshint plusplus: false
				while (text.length > 0 && currentLines > maxLines && maxCutCharacters-- > 0) {
					text = text.substr(0, text.length - 1);
					element.text(text + '\u2026');
					currentLines = Math.round(element.height() / lineHeight);
				}

				element.css({
					'max-height': previousMaxHeight,
					'height': previousHeight
				});
			}
		});
	};

	// Strips HTML (from safe sources like the GSA), flattens tags and unescapes entities
	SearchResultContainer.unsafelyStripHTML = function(html) {
		return $('<div/>').html(html).text();
	};

	// Make the hightlights in the snippets survive the HTML stripping (as snabbdom VDom elements)
	SearchResultContainer.snippetToVDomElements = function(html, h) {
		html = html.split(/<\/?b>/g);
		return $.map(html, function(text, i) {
			text = SearchResultContainer.unsafelyStripHTML(text);
			var plain = i%2 === 0;
			if(plain) {
				return text;
			}
			return h('em.highlight', [text]);
		});
	};

	// Prepares a data object for click tracking, sends it off to the processor
	SearchResultContainer.trackClick = function(cType, config, item, processor) {
		var data = SCS.search.util.extend({}, config, item, {
			ctype: cType || 'c',
			start: config.offset,
			href: item.url || item.link
		});
		processor.track('generalClick', data);
	};



	Module.SearchResultContainer = SearchResultContainer;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultContainer.js
// module id = 71
// module chunks = 0